<!-- Button -->
<button matTooltip="Panel administracyjny" mat-icon-button *ngIf="isAdmin" [routerLink]="'/admin'">
    <mat-icon color="primary"  [svgIcon]="'tabler_outline:user-bolt'"></mat-icon>
</button>
<button matTooltip="My account"
    mat-icon-button
    [matMenuTriggerFor]="userActions">
    <span class="relative">
        <img
            class="w-7 h-7 rounded-full"
            *ngIf="showAvatar && user.avatar"
            [src]="user.avatar">
        <mat-icon
            *ngIf="!showAvatar || !user.avatar"
            [svgIcon]="'tabler_outline:user-circle'"></mat-icon>
        <span
            class="absolute right-0 bottom-0 w-2 h-2 rounded-full"
            [ngClass]="{'mr-px mb-px bg-green-500': !showAvatar || !user?.avatar }"
        ></span>
    </span>
</button>

<mat-menu
    [xPosition]="'before'"
    #userActions="matMenu">
    <button mat-menu-item>
        <span class="flex flex-col leading-none">
            <span>Logged as</span>
            <span class="mt-1.5 text-md font-medium">{{user.emailAddress}}</span>
        </span>
    </button>
    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item [routerLink]="'/account/my-account'">
        <mat-icon [svgIcon]="'tabler_outline:user'"></mat-icon>
        <span>My account</span>
    </button>
    <a *ngIf="user.role === 'user'" mat-menu-item [routerLink]="'/account/my-account/subscription'">
        <mat-icon [svgIcon]="'tabler_outline:credit-card'"></mat-icon>
        <span>Subscription</span>
    </a>
    <a mat-menu-item [routerLink]="'/account/settings'">
        <mat-icon [svgIcon]="'tabler_outline:settings'"></mat-icon>
        <span>Settings</span>
    </a>
    <!-- <button
        mat-menu-item
        [matMenuTriggerFor]="userStatus">
        <mat-icon [svgIcon]="'heroicons_outline:ellipsis-horizontal-circle'"></mat-icon>
        <span>Status</span>
    </button> -->
    <mat-divider class="my-2"></mat-divider>
    
    <button
        mat-menu-item
        (click)="signOut()">
        <mat-icon [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"></mat-icon>
        <span>Sign out</span>
    </button>
</mat-menu>

<!-- <mat-menu
    class="user-status-menu"
    #userStatus="matMenu">
    <button
        mat-menu-item
        (click)="updateUserStatus('online')">
        <span class="w-4 h-4 mr-3 rounded-full bg-green-500"></span>
        <span>Online</span>
    </button>
    <button
        mat-menu-item
        (click)="updateUserStatus('away')">
        <span class="w-4 h-4 mr-3 rounded-full bg-amber-500"></span>
        <span>Away</span>
    </button>
    <button
        mat-menu-item
        (click)="updateUserStatus('busy')">
        <span class="w-4 h-4 mr-3 rounded-full bg-red-500"></span>
        <span>Busy</span>
    </button>
    <button
        mat-menu-item
        (click)="updateUserStatus('not-visible')">
        <span class="w-4 h-4 mr-3 rounded-full bg-gray-400"></span>
        <span>Invisible</span>
    </button>
</mat-menu> -->
